import Honeybadger from '@honeybadger-io/js';

/**
 * Initialize Honeybadger for frontend error tracking
 * Only active in production environment with valid API key
 *
 * IMPORTANT: This function includes comprehensive error handling to ensure
 * it never blocks the application, even if configuration is missing or invalid.
 */
export function initializeHoneybadger() {
  try {
    // Get configuration from meta tags set by Rails
    const apiKeyMeta = document.querySelector('meta[name="honeybadger-api-key"]');
    const environmentMeta = document.querySelector('meta[name="honeybadger-environment"]');
    const revisionMeta = document.querySelector('meta[name="app-revision"]');

    const apiKey = apiKeyMeta?.content;
    const environment = environmentMeta?.content || 'production';
    const revision = revisionMeta?.content || 'unknown';

    // Only initialize if we have an API key
    if (!apiKey || apiKey === '') {
      console.info('Honeybadger: No API key found, skipping initialization');
      return;
    }

    // Only track errors in production/staging
    if (environment === 'development' || environment === 'test') {
      console.info(`Honeybadger: Disabled in ${environment} environment`);
      return;
    }

    // Initialize Honeybadger with safe defaults
    Honeybadger.configure({
      apiKey,
      environment,
      revision,
      reportData: true,
      enableUnhandledRejection: true,
      enableUncaught: true,
      breadcrumbsEnabled: true,
      maxBreadcrumbs: 40,
      debug: true,   // Enable debug mode to see detailed error messages
      async: true    // Use fetch API instead of beacon for better CORS support
    });

    // Expose Honeybadger to global scope for testing in browser console
    window.Honeybadger = Honeybadger;

    console.info('Honeybadger: Initialized successfully');
  } catch (error) {
    // CRITICAL: Never let Honeybadger initialization errors break the app
    console.error('Honeybadger: Failed to initialize', error);
    // Silently fail - the app must continue to work
  }
}

export default Honeybadger;
